export class BreadcrumbItem {
  public nom: string;
  public url: string;

  constructor(nom: string, url: string = null) {
    this.nom = nom;
    this.url = url;
  }
}
